import React, { useState, useEffect } from "react";
import iconre from "../../static/message.png";
import newMessage from "../../assets/envelope.png";
import { ReactComponent as Envelope } from "../../assets/envelop.svg";
import "./InstruccionGeo.scss";
import { Container, Row, Col } from "react-bootstrap";
import {
  infoMessage2,
  successMessage,
} from "../utils/ErrorHandler/errorHandler";
import { useHistory, Link } from "react-router-dom";
import { Button3 } from "../utils/Buttons/Buttons";
import useQuery from "../../hooks/useQuery";
import { addEvent } from "../api/Events/EventsApi";
import StorageManager from "../utils/StorageManager";
import TopAppBar from "../AppBar/TopAppBar";
import BottomAppBar from "../AppBar/BottomAppBar";
function VerifyMailPage(props) {
  let history = useHistory();
  const [mostrarEnviar, setMostrarEnviar] = useState(false);
  const [bottomAppBarHeight, setBottomAppBarHeight] = useState("");
  const query = useQuery();
  const UrlCode = query.get("code");

  const [isInPlace, setIsInPlace] = useState(false);

  function getTime() {
    var d = new Date();
    return d.getTime();
  }

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  console.log(props.email, "PROPSSS EMAILLLL");

  const storageManager = new StorageManager();

  async function verifyOtp() {
    const api = props.api;
    let result = await api.didOtpAndMail();
    console.log("RESULTT>>>> : ", result);
    if (result) {
      successMessage("Correo confirmado!").then(() => {
        console.log("PROPS EMAIL:", props, "AND");
        // props.verifyOtp();
        // history.push(`direction/?code=${UrlCode}`);
        history.push(`vsms/?code=${UrlCode}`);

        console.log(UrlCode, "URLCODE");
      });
    } else {
      console.log("No has confirmado tu correo!");
      infoMessage2("No has confirmado tu correo!");
    }
  }

  useEffect(() => {
    let project = storageManager.getProject();
    if (project) {
      if (project.hasEmailConfirmation === false) {
        history.push(`/final?code=${UrlCode}`);
        return;
      }
      if (project.extraConfig.inplaceEmailVerification === true) {
        setIsInPlace(true);
      }
    }
    if(bottomAppBarHeight !== "")
    {
      var tamanio = 100 - bottomAppBarHeight.split("%")[0];
      document.getElementById("contenedorVerifyEmailPage").style.height = tamanio + "vh";
    }
    if(bottomAppBarHeight === ""){
      // props.api.sendEmail();
      addEvent("STEP_EMAIL", {}, {}, "interaction");
      props.api.sendEmailNew();
      showEnviar();
    }    
  }, [bottomAppBarHeight]);

  async function waitForEmail() {
    let secondsToWait = 1000;
    let flag = await props.api.didEmail();
    let initialTime = null;
    while (!flag) {
      if (!initialTime) initialTime = getTime();
      await sleep(2000);
      flag = await props.api.didEmail();
      console.log("didEmail:");
      console.log(flag);
      let dif = getTime() - initialTime;
      console.log("time dif: " + dif);
      if (dif > secondsToWait * 1000) {
        flag = true;
      }
    }
    history.push(`/final?code=${UrlCode}`);
  }

  function gotoClose() {
    history.push("/closeWindow");
  }

  useEffect(() => {
    console.log("Is In Place useEffect");
    if (isInPlace) {
      console.log("Is In Place TRUE");
      waitForEmail();
    }
  }, [isInPlace]);

  async function showEnviar() {
    await sleep(5000);
    setMostrarEnviar(true);
  }

  async function resend() {
    addEvent("EMAIL_RESEND", {}, {}, "interaction");
    setMostrarEnviar(false);
    props.api.sendEmailNew();
    await infoMessage2("Correo reenviado!");
    showEnviar();
  }

  function modifyEmail(){
    history.push(`email/?code=${UrlCode}`);
  }

  function handleCallback(bottomAppBar){
    setBottomAppBarHeight(bottomAppBar);
  }

  return (
    <div id="contenedorVerifyEmailPage" className="App" style={{ color: "black", height: "92vh" }}>
      <TopAppBar/>
      <Container className="container_instruccionGeo">
        <Row>
          <Col style={{ color: "white" }}>
            <div style={{display: "flex", alignItems: "center", marginTop: "40%"}}>
              <Envelope />
              <p className="text_2">Revisa tu correo!</p>
            </div>
            <p className="text_1">Te hemos enviado<br/>un correo a:</p>
            <h4 className="text_6">{props.email}</h4>
            <p className="text_1" style={{ marginTop: "0px" }}>
              Para que continues <br />
              tu proceso
            </p>
            <p className="text_4">
              {" "}
              Dentro de los siguientes 30 segundos <br></br> llegará este correo
              electrónico, si no <br></br>llega a tu cuenta, oprime <br></br>{" "}
              RE-ENVIAR CORREO
            </p>
            
            <p className="text_3">
              Una vez llegue el correo
            </p>
            <p className="text_7">
              puedes cerrar esta ventana
            </p>

            <p className="text8" style={{ marginTop: "2em" }}>
              Si por algun motivo no esta el correo en<br></br> tu bandeja de
              entrada revisa la carpeta<br></br>
              de spam
            </p>
          </Col>
        </Row>
      </Container>
      <BottomAppBar parentCallback={handleCallback} fontSize={global.fontSize} botonReenviarCorreoHabilitado={true} botonModificarCorreoHabilitado={true} botonOptionsHabilitado={true} botonReenviarCorreoClick={resend} botonModificarCorreoClick={modifyEmail}/>
    </div>
  );
}

export default VerifyMailPage;
